// src/components/european-formula/ImageUpload.js

import React, { useState, useCallback } from 'react';
import ImageSelector from './ImageSelector';
import '../tools.css';
import SavedSessionsGallery from './SavedSessionsGallery';
import { getSubImagesByOriginalImageNameAndTool } from '../../indexedDB';
import PropTypes from 'prop-types';

function ImageUpload({ user, userInfo }) { // Riceviamo user e userInfo come props
  const [userEmail] = useState(user.email || '');
  const [imageFile, setImageFile] = useState(null);
  const [step, setStep] = useState(1);
  const [tipo, setTipo] = useState('');
  const [posizione, setPosizione] = useState('');
  const [loadedSession, setLoadedSession] = useState(null);
  const [subImages, setSubImages] = useState([]);
  const [sesso, setSesso] = useState('');
  const [realAge, setRealAge] = useState(''); // New state for real age

  const [sessionsCount, setSessionsCount] = useState(0);

  const handleSaveSessoAndRegione = useCallback(() => {
    if (sesso && imageFile) {
      setStep(3); // Proceed to the next step
    } else {
      alert('Please select gender before saving.');
    }
  }, [sesso, imageFile]);
  

  // const getDataURL = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onload = () => resolve(reader.result);
  //     reader.onerror = (error) => reject(error);
  //     reader.readAsDataURL(file);
  //   });
  // };

  // Gestione della selezione dell'immagine
  const handleImageChange = useCallback((e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setStep(2);
    }
  }, []);

  // Seleziona una sessione salvata
  const handleSelectSession = useCallback(async (originalSession) => {
    try {
      const toolForSubImages = 'european-formula'; // Sostituisci con il tool effettivamente usato per le sotto-immagini
      const fetchedSubImages = await getSubImagesByOriginalImageNameAndTool(
        userEmail,
        originalSession.subImage.name,
        toolForSubImages
      );

      if (fetchedSubImages.length === 0) {
        alert('No sub-images found for the selected session.');
        return;
      }

      setImageFile(null);
      setTipo(originalSession.tipo || '');
      setPosizione(originalSession.posizione || '');
      setSesso(originalSession.sesso || '');
      setRealAge(originalSession.realAge || ''); // Set real age from session
      setLoadedSession(originalSession);
      setSubImages(fetchedSubImages);
      setStep(3);
    } catch (error) {
      console.error('Error with subimages', error);
      alert('Error fetching subimages. Please try again later.');
    }
  }, [userEmail]);

  // Aggiorna il conteggio delle sessioni
  const updateSessionsCount = useCallback(() => {
    setSessionsCount((prev) => prev + 1);
  }, []);

  // Rendering condizionale in base allo stato
  return (
    <div className="tool-container">

      {step === 1 && (
        <div className="upload-step">
          <h2 className="step-title">Step 1: Upload Image</h2>
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {imageFile && <p>Selected image: {imageFile.name}</p>}
        </div>
      )}

      {step === 2 && (
        <div className="selection-step">
          <h2 className="step-title">Step 2: Select Gender</h2>
          <h4>Selected image: {imageFile.name}</h4>

          <div className="selection-group">
            <h4>Select Gender</h4>
            <label>
              <input
                type="radio"
                value="M"
                checked={sesso === 'M'}
                onChange={(e) => setSesso(e.target.value)}
              />
              Male
            </label>
            <br />
            <label>
              <input
                type="radio"
                value="F"
                checked={sesso === 'F'}
                onChange={(e) => setSesso(e.target.value)}
              />
              Female
            </label>
          </div>

          <div className="selection-group">
            <h4>Real Age (Optional)</h4>
            <input
              type="number"
              min="0"
              max="120"
              value={realAge}
              onChange={(e) => setRealAge(e.target.value)}
              placeholder="Enter real age"
              className="age-input"
            />
          </div>

          <button onClick={handleSaveSessoAndRegione} className="save-button">
            Save Data
          </button>
        </div>
      )}

      {step === 3 && (imageFile || loadedSession) && (
        <ImageSelector
          imageFile={imageFile}
          userEmail={userEmail}
          sesso={sesso}
          realAge={realAge} // Pass real age to ImageSelector
          tipo={tipo}
          posizione={posizione}
          selectionRequired={true}
          maxTotalPoints={7}
          colorCategories={['blue']}
          categoryColors={{ blue: 'blue' }}
          passCategoryToAnnotation={true}
          maxPointsPerCategory={{ blue: 7 }}
          useLeftRightInNames={true}
          categoriesToAnnotate={['blue']}
          loadedSession={loadedSession}
          loadedSubImages={subImages} // Passa le sotto-immagini
          updateSessionsCount={updateSessionsCount}
          userInfo={userInfo} // Passiamo userInfo se necessario
        />
      )}

      {step === 1 && (
        <SavedSessionsGallery
          onSelectSession={handleSelectSession}
          sessionsCount={sessionsCount}
          userEmail={userEmail}
          userInfo={userInfo} // Passa userInfo se necessario
        />
      )}
    </div>
  );
}

// Definizione dei tipi delle props per una migliore manutenibilità e debugging
ImageUpload.propTypes = {
  user: PropTypes.object.isRequired,
  userInfo: PropTypes.object,
};

export default ImageUpload;
